module.exports = "https://lts-static.prod-my.games/promo/lp1/img/android.9f703e05.svg";